import { EXPERTLINK_FLAG, IExpertLinkMachineEligibility, isExpertLinkEligible } from '../expertLink';
import { useLaunchDarkly } from '../../store/LaunchDarkly';
import { IMachineDetails } from '../../store/MachineDetails/types';

// `category.key` is null on payloads where the backend cannot resolve it, so the display name stands in.
export const toExpertLinkMachine = (machine?: IMachineDetails): IExpertLinkMachineEligibility => ({
  vin: machine?.vin,
  brand: machine?.brand?.name,
  categoryKey: machine?.subCategory?.category?.key ?? machine?.subCategory?.category?.defaultDisplayName,
});

export const useExpertLinkFlagEnabled = (): boolean => {
  const launchDarkly = useLaunchDarkly();

  return !!launchDarkly[EXPERTLINK_FLAG];
};

export const useExpertLinkEnabled = (machine?: IMachineDetails): boolean => {
  const flagEnabled = useExpertLinkFlagEnabled();

  return flagEnabled && isExpertLinkEligible(toExpertLinkMachine(machine));
};
